import { useEffect, useState } from "react";
import { RxEnterFullScreen } from "react-icons/rx";
import { MdDownload } from "react-icons/md";

const DocumentViewer = ({ url, contentType, fileName, onClose }) => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = () => {
    setIsLoading(true);

    try {
      // click an <a/> with set file url and download attr (file name) to download the file
      const a = document.createElement("a");
      a.href = url;
      const parts = contentType.split("/");
      a.download = fileName + "." + parts[parts.length - 1];
      document.body.appendChild(a);
      a.click();
      document.body.removeChild();
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setIsFullscreen(false);
    // When a parent owns the blob (e.g. Approve bank details), it revokes in onClose after Bootstrap finishes hiding.
    if (onClose == null) {
      URL.revokeObjectURL(url);
    }
  };

  useEffect(() => {
    if (onClose == null) return;
    const el = document.getElementById("staticBackdropDocumentViewer");
    if (el == null) return;
    const handler = () => onClose();
    el.addEventListener("hidden.bs.modal", handler);
    return () => {
      el.removeEventListener("hidden.bs.modal", handler);
    };
  }, [onClose]);

  return (
    <div
      className="modal fade modal-document-viewer-wrapper"
      id="staticBackdropDocumentViewer"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div
        className={`modal-dialog modal-dialog-centered ${
          isFullscreen && "modal-fullscreen"
        } ${contentType === "application/pdf" && "modal-xl"}`}
      >
        <div className="modal-content">
          <div className="modal-header modal-document-viewer-header">
            <div className="modal-document-viewer-title">
              <h5 className="m-0 fs-6">{fileName}</h5>
            </div>
            <div className="modal-document-viewer-actions d-flex align-items-center gap-1">
              <button
                type="button"
                className="btn modal-header-btn"
                onClick={() => setIsFullscreen((prev) => !prev)}
              >
                <RxEnterFullScreen size="1.4rem" />
              </button>
              {contentType !== "application/pdf" && (
                <button type="button" className="btn modal-header-btn">
                  <MdDownload
                    size="1.5rem"
                    style={{ paddingTop: "2px" }}
                    onClick={handleDownload}
                  />
                </button>
              )}
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleClose}
              ></button>
            </div>
          </div>
          <div
            className={`modal-body modal-document-viewer-body ${
              contentType === "application/pdf" && "modal-pdf"
            }`}
          >
            {contentType === "application/pdf" ? (
              <iframe src={url} width="100%" height="100%" />
            ) : (
              <img
                src={url}
                style={{ width: "100%", height: "100%", objectFit: "contain" , borderRadius: " 24px"}}
              />
            )}
          </div>
          {/* <div className="modal-footer"></div> */}
        </div>
      </div>
    </div>
  );
};

export default DocumentViewer;
